import { IResponseProcessor } from "..";
import { IOrderDetailResult } from "../document/DocumentsApi";
import { IInventoryValue } from "../manufacturer/ManufacturersApi";
import { IProduct } from "../product/ProductsApi";

// DEPRECATED: This class is part of the legacy MobX data-fetching layer.
// All new code should use RTK Query hooks from the 'randmar-api-client' package.
// This class will be removed once all components using CategoriesStore have been migrated.
export default class CategoriesApi {
  constructor(
    private _baseUrl: string,
    private _getToken: (applicationId: string) => string,
    private _processor: IResponseProcessor
  ) {
    console.warn(
      "Deprecation Warning: The legacy 'CategoriesApi' class is in use. Refer to CONTRIBUTING.md and use the RTK Query hooks from 'randmar-api-client' for new and refactored code."
    );
  }

  private async _fetch(applicationId: string, path: string, options: RequestInit = {}) {
    const res = await fetch(`${this._baseUrl}/${applicationId}${path}`, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${this._getToken(applicationId)}`,
      },
    });

    this._processor.process(res);
    return res;
  }

  private async _fetchAndJson<T>(applicationId: string, path: string, options: RequestInit = {}): Promise<T> {
    const res = await this._fetch(applicationId, path, options);
    return res.json();
  }

  /**
   * @deprecated use `useGetV4ManufacturerByRouteManufacturerIdCategoriesQuery` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async getCategories(applicationId: string): Promise<ICategory[]> {
    return this._fetchAndJson<ICategory[]>(applicationId, "/Categories");
  }

  /**
   * @deprecated use `useGetV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeQuery` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async getCategory(applicationId: string, categoryCode: string): Promise<ICategory> {
    return this._fetchAndJson<ICategory>(applicationId, `/Category/${encodeURIComponent(categoryCode)}`);
  }

  /**
   * @deprecated use `usePostV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeFieldNameMutation` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`, and `fieldId` maps to `fieldName`.
   */
  async updateCategoryProperty(
    applicationId: string,
    categoryCode: string,
    fieldId: string,
    newValue: string
  ): Promise<boolean> {
    const path = `/Category/${encodeURIComponent(categoryCode)}/${fieldId}?newValue=${encodeURIComponent(newValue)}`;
    return this._fetchAndJson<boolean>(applicationId, path, { method: "POST" });
  }

  /**
   * @deprecated use `useDeleteV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeMutation` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async deleteCategory(applicationId: string, categoryCode: string): Promise<boolean> {
    return this._fetchAndJson<boolean>(applicationId, `/Category/${encodeURIComponent(categoryCode)}`, { method: "DELETE" });
  }

  /**
   * @deprecated use `usePostV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeResetMutation` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async resetCategory(applicationId: string, categoryCode: string): Promise<boolean> {
    return this._fetchAndJson<boolean>(applicationId, `/Category/${encodeURIComponent(categoryCode)}/Reset`, { method: "POST" });
  }

  /**
   * @deprecated use `usePutV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeStarredMutation` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async starCategory(applicationId: string, categoryCode: string): Promise<boolean> {
    return this._fetchAndJson<boolean>(applicationId, `/Category/${encodeURIComponent(categoryCode)}/Starred`, { method: "PUT" });
  }

  /**
   * @deprecated use `usePutV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeMutation` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async createCategory(applicationId: string, categoryCode: string): Promise<string> {
    const path = `/Category/${encodeURIComponent(categoryCode)}`;
    const res = await this._fetch(applicationId, path, { method: "PUT" });
    return await res.text();
  }

  /**
   * @deprecated use `usePostV4ManufacturerByRouteManufacturerIdCategoryAndCategoryCodeImageMutation` from `randmar-api-client` instead.
   * Note: `applicationId` maps to `routeManufacturerId`.
   */
  async uploadProductTypeImage(applicationId: string, categoryCode: string, selectedFile: File): Promise<boolean> {
    const dataFile = new FormData();
    dataFile.append('file', selectedFile);

    const res = await this._fetch(applicationId, `/Category/${encodeURIComponent(categoryCode)}/Image`, {
      method: "POST",
      body: dataFile
    });

    return await res.ok;
  }
}

export interface ICategory {
  CategoryName: string;
  CategoryCode: string;
  A_GP: number;
  B_GP: number;
  C_GP: number;
  D_GP: number;
  Cost_GP: number;
  Niche: string;
  LeadTime: number;
  MinimumOrder: number;
  WeeksOfStocking: number;
  InventoryValue: IInventoryValue[];
  OpenOrders: IOrderDetailResult[];
  Products: IProduct[];
  Starred: boolean;
  AutoReorder: boolean;
  QualificationRequired: boolean;
}
